/**
 * Created by slava on 20/3/20
 */

MovesLog.MOVE_SHIFT_CARD = 1;
MovesLog.MOVE_USE_BOOSTER = 2;

MovesLog.prototype.executeUndo = function () {
    const move = this.log.pop();

    switch (move.type) {
        case MovesLog.MOVE_SHIFT_CARD:
            var card = this.tilegame.open.pop();
            this.tilegame.unShiftCard(card);
            break;

        case MovesLog.MOVE_PLAY_CARD:
            this.undoPlayCard();
            break;

        case MovesLog.MOVE_USE_BOOSTER:
            var booster = cleverapps.boosters.getBoosterById(move.options.id);
            booster.makeUndo();
            break;
    }

    if (move.type !== MovesLog.MOVE_USE_BOOSTER) {
        if (this.tilegame.combo) {
            if (move.options && move.options.comboLevel) {
                while (this.tilegame.combo.level < move.options.comboLevel) {
                    this.tilegame.combo.increaseLevel();
                }
            } else {
                if (move.options && move.options.resetAfterPrize !== undefined) {
                    this.tilegame.combo.resetAfterPrize = move.options.resetAfterPrize;
                }
                this.tilegame.combo.decreaseLevel();
            }
        }

        if (this.tilegame.table.streakCard) {
            this.tilegame.table.streakCard.decreaseLevel();
        }
    }

    this.trigger("change");
    this.tilegame.move = Card.MOVES.UNDO;
    this.tilegame.counter.trigger();
};

MovesLog.prototype.isUndoNeedOnPreviousMove = function () {
    const lastMove = this.getLastMove();

    return lastMove && lastMove.options && lastMove.options.undoRecommended;
};
